import React, { useState, useEffect } from "react";
import Axios from "axios";

function Studentcommission({ email }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");
  const [amountValues, setAmountValues] = useState({});
  const [statusValues, setStatusValues] = useState({});
  const [savedById, setSavedById] = useState({});

  const keyOfRow = (r) =>
    [
      r.stdcpncde || "-",
      r.customer_email || "-",
      r.id || "-",
      r.createdAt ? new Date(r.createdAt).toISOString().slice(0, 10) : "-",
    ].join("|");

  const keyOfDoc = (d) =>
    [
      d.referralCode || "-",
      d.customerEmail || "-",
      d.productId || "-",
      d.purchaseDate
        ? new Date(d.purchaseDate).toISOString().slice(0, 10)
        : "-",
    ].join("|");

  useEffect(() => {
    if (!email) {
      setErr("No logged-in email found.");
      setLoading(false);
      return;
    }
    (async () => {
      try {
        const [discRes, codeRes] = await Promise.all([
          Axios.get("https://onlineexam.ssccglpinnacle.com/student-discounts"),
          Axios.get("https://onlineexam.ssccglpinnacle.com/stdcpncde"),
        ]);

        const discMap = Object.fromEntries(
          (Array.isArray(discRes.data) ? discRes.data : [discRes.data]).map(
            (d) => [(d.category || "").toLowerCase(), d.minDiscount]
          )
        );

        const list = Array.isArray(codeRes.data)
          ? codeRes.data
          : [codeRes.data];

        const merged = list
          .map((r) => {
            let category = "test series";
            const oid = r.order_id || "";

            if (oid.startsWith("book_web")) category = "books";
            else if (oid.startsWith("video_web")) category = "video courses";
            else if (oid.startsWith("ebook_web")) category = "ebooks";
            else if (oid.startsWith("typing_web")) category = "typing";
            else if (/^\d+/.test(oid)) category = "test series";

            return {
              ...r,
              category,
              minDiscount:
                discMap[category.toLowerCase()] ?? r.minDiscount ?? "-",
            };
          })
          .reverse();

        const commRes = await Axios.get(
          "https://nodei.ssccglpinnacle.com/student-commissions"
        );
        const docs = Array.isArray(commRes?.data?.data)
          ? commRes.data.data
          : [];
        const docMap = Object.fromEntries(docs.map((d) => [keyOfDoc(d), d]));

        const mergedWithPersist = merged.map((r) => {
          const hit = docMap[keyOfRow(r)];
          return hit
            ? {
                ...r,
                paidStatus: hit.paidStatus,
                amountPaid: hit.amountPaid,
                _saved: true,
              }
            : r;
        });

        const filteredData = mergedWithPersist.filter(
          (r) => r.senderEmail?.toLowerCase() === email.toLowerCase()
        );

        setData(filteredData);

        const nextSaved = {};
        filteredData.forEach((r) => {
          if (r.paidStatus) nextSaved[r.id] = true;
        });
        setSavedById(nextSaved);
      } catch (e) {
        setErr(e?.response?.data?.message || "Failed to load data");
      } finally {
        setLoading(false);
      }
    })();
  }, [email]);

  const commissionIfSuccess = (row) => {
    const isSuccess =
      String(row?.paymentStatus || "").toLowerCase() === "success";
    const priceNum = Number(row?.price);
    const discNum = Number(parseFloat(row?.minDiscount));
    if (!isSuccess) return "-";
    if (Number.isNaN(priceNum) || Number.isNaN(discNum)) return "-";
    return ((priceNum * discNum) / 100).toFixed(2);
  };

  const handleAmountChange = (id, value) => {
    setAmountValues((prev) => ({ ...prev, [id]: value }));
  };

  const handleStatusChange = (id, value) => {
    setStatusValues((prev) => ({ ...prev, [id]: value }));
  };

  const handleSave = async (id) => {
    try {
      const row = data.find((d) => String(d.id) === String(id));
      if (!row) return alert("Row not found");

      const amountPaid = Number(amountValues[id] ?? 0);
      const paidStatus =
        (statusValues[id] ?? "").toLowerCase() ||
        (amountPaid > 0 ? "paid" : "unpaid");

      const res = await Axios.post(
        "https://nodei.ssccglpinnacle.com/student-commissions",
        {
          row,
          amountPaid,
          paidStatus,
        }
      );

      const savedDoc = res?.data?.data;

      setData((prev) =>
        prev.map((r) =>
          String(r.id) === String(id)
            ? {
                ...r,
                paidStatus: savedDoc?.paidStatus || paidStatus,
                amountPaid: savedDoc?.amountPaid ?? amountPaid,
              }
            : r
        )
      );
      setSavedById((prev) => ({ ...prev, [id]: true }));
      alert("Saved!");
    } catch (e) {
      console.error(e);
      alert(e?.response?.data?.message || "Save failed");
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "1rem" }}>Loading...</div>
    );
  }
  if (err) {
    return (
      <div style={{ color: "red", textAlign: "center", marginTop: "1rem" }}>
        {err}
      </div>
    );
  }
  return (
    <div>
      <h2 style={{ textAlign: "center", marginTop: "1rem" }}>
        Student Purchase/Transaction By Referral Code
      </h2>
      <br />
      <div style={{ overflowX: "auto", width: "100%" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            tableLayout: "auto",
            minWidth: "800px",
            textAlign: "center",
            whiteSpace: "nowrap",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Sr.No
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Sender Email
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Referral Code
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Referral Date
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Customer Email
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Order Id
              </th>

              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Product Id
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Title
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Selling Price
              </th>

              {/* <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Purchase Price
              </th> */}
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Purchase Date
              </th>

              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Coins Redeem
              </th>

              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Status
              </th>

              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Category
              </th>
              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Student Commission (%)
              </th>

              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Student Commission (Rs)
              </th>

              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Amount Paid (Rs)
              </th>

              <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Paid/Unpaid
              </th>
              {/* <th
                style={{
                  border: "1px solid #ccc",
                  padding: "8px",
                  textAlign: "center",
                }}
              >
                Action
              </th> */}
            </tr>
          </thead>
          <tbody>
            {data.map((row, idx) => (
              <tr key={`${row.stdcpncde || "code"}-${idx}`}>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {idx + 1}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.senderEmail || "-"}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.stdcpncde || "-"}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.timestamp
                    ? new Date(row.timestamp).toLocaleDateString("en-GB")
                    : "-"}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.customer_email || "-"}
                </td>

                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.order_id || "-"}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.id || "-"}
                </td>
                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                    maxWidth: "400px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  title={row.title}
                >
                  {row.title || "-"}
                </td>

                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.price || "-"}
                </td>

                {/* <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.amountPaid || "-"}
                </td> */}

                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.createdAt
                    ? new Date(row.createdAt).toLocaleDateString("en-GB")
                    : "-"}
                </td>

                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.redeemCoins || "-"}
                </td>

                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                    color:
                      row.paymentStatus?.toLowerCase() === "success"
                        ? "green"
                        : "red",
                    fontWeight: "bold",
                  }}
                >
                  {row.paymentStatus || "-"}
                </td>

                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.category || "-"}
                </td>

                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.minDiscount || "-"}%
                </td>

                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.price && row.minDiscount
                    ? (
                        (parseFloat(row.price) * parseFloat(row.minDiscount)) /
                        100
                      ).toFixed(2)
                    : "-"}
                </td>

                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {commissionIfSuccess(row)}
                </td>

                <td
                  style={{
                    border: "1px solid #ccc",
                    padding: "8px",
                    textAlign: "center",
                  }}
                >
                  {row.paidStatus ? (
                    <span
                      style={{
                        display: "inline-block",
                        padding: "4px 10px",
                        borderRadius: "6px",
                        backgroundColor:
                          row.paidStatus.toLowerCase() === "paid"
                            ? "#2e7d32"
                            : "#b71c1c",
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "12px",
                        textTransform: "uppercase",
                      }}
                    >
                      {row.paidStatus}
                    </span>
                  ) : (
                    "-"
                  )}
                </td>

                {/* <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  <select
                    value={statusValues[row.id] ?? ""}
                    onChange={(e) => handleStatusChange(row.id, e.target.value)}
                    style={{ width: 100, padding: 4, marginRight: 6 }}
                  >
                    <option value="">select</option>
                    <option value="paid">paid</option>
                    <option value="unpaid">unpaid</option>
                  </select>

                  <button
                    onClick={() => handleSave(row.id)}
                    style={{
                      padding: "5px 12px",
                      cursor: "pointer",
                      backgroundColor: "#4CAF50",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      fontSize: "14px",
                      fontWeight: "bold",
                      transition: "background-color 0.3s ease",
                    }}
                    onMouseOver={(e) =>
                      (e.target.style.backgroundColor = "#45a049")
                    }
                    onMouseOut={(e) =>
                      (e.target.style.backgroundColor = "#4CAF50")
                    }
                  >
                    Save
                  </button>
                </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Studentcommission;
